export const SITE_CONFIGURATION = {
  SITE_NAME: process.env.REACT_APP_WEBSITE_NAME,
};
